import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-newsletter-popup',
    templateUrl: './newsletter-popup.component.html',
    styleUrls: ['./newsletter-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsletterPopupComponent implements OnInit {
  // toggler: boolean = true;
  toggleDisplay = true;
  removePopup = true;
  constructor() { }

  toggleOff(){
    // this.removePopup = false;
    this.toggleDisplay = !this.toggleDisplay;
  }
  toggle() {
    console.log('toggle')
    this.toggleDisplay = !this.toggleDisplay;
  }
  ngOnInit() {
  }

}
